<template>
    <div>
        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
            <div class="flex-grid__item">
                <div>
                    <h2>
                        Interim Payments
                    </h2>
                </div>
                <p v-if="interimPayments.length === 0">
                    Add details of any Interim Payments using the button below:
                </p>
                <div v-for="(interimPayment, index) in interimPayments" class="dependant a-form-inputs--section">
                    <payment :index="index"></payment>
                </div>
                <div class="flex-grid__g-8">
                    <button class="a-button" @click="addPayment">Add Interim Payment</button>
                </div>
            </div>

            <div class="flex-grid__item flex-grid--space-left">
                <div class="a-form-inputs">
                    <div>
                        <h2>
                            Interest
                        </h2>
                    </div>
                    <control label="Calculate Interest Rates to">
                        <select v-model="interestType" @change="calcAllInterest">
                            <option value="none">Do not apply interest</option>
                            <option value="today">Today</option>
                            <option value="assumed_settlement">Assumed Settlement</option>
                            <option value="custom">Custom</option>
                        </select>
                    </control>
                    <control label="Custom date" for="custom_interest_date" v-if="interestType === 'custom'">
                        <date-input v-model="customInterestDate" @input="calcAllInterest"></date-input>
                        <control-error :show="!isValidDate">
                            Date is required, must be in the format DD/MM/YYYY
                        </control-error>
                        <control-error :show="!isValidInterestDate">
                            Date must be after the Date of Injury {{ getClaimInfo('dateOfInjury') }}
                        </control-error>
                    </control>

                    <div class="a-table--short-no-style" v-if="interestType !== 'none'">
                        <div class="m-div-table__holder m-div-table__holder--less-margin">
                            <interest-item
                                    v-if="showGeneralDamages"
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('generalDamagesInterest')"
                                    :option="{name: 'generalDamages'}"
                                    :unique-id="uniqueId"
                                    :value="value('generalDamagesWithInterest')"
                                    tip-name="general_damages"
                                    title="General Damages"
                                    updates="generalDamages">
                            </interest-item>
                            <interest-item
                                    v-if="pastLossOfEarnings"
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastLossOfEarningsInterest')"
                                    :option="{name: 'pastLossOfEarnings'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastLossOfEarningsWithInterest')"
                                    tip-name="past_loss_of_earnings"
                                    title="Past Loss of Earnings"
                                    updates="pastLossOfEarningsInterest">
                            </interest-item>
                            <interest-item
                                    v-if="value('pastCostOfServices') > 0"
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastCostOfServicesInterest')"
                                    :option="{name: 'pastCostOfServices'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastCostOfServicesWithInterest')"
                                    tip-name="past_cost_of_services"
                                    title="Past Cost of Services"
                                    updates="pastCostOfServicesInterest">
                            </interest-item>
                            <interest-item
                                    v-if="value('pastCostOfTravel') > 0"
                                    @update="onUpdate"
                                    :payload="payload"
                                    name="pastCostOfCare"
                                    :interest="value('pastCostOfTravelInterest')"
                                    :option="{name: 'pastCostOfTravel'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastCostOfCareWithInterest')"
                                    tip-name="past_cost_of_travel"
                                    title="Past Cost Of Travel"
                                    updates="pastCostOfTravelInterest">
                            </interest-item>
                            <interest-item
                                    v-if="value('misc') > 0"
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('miscInterest')"
                                    :option="{name: 'misc'}"
                                    :unique-id="uniqueId"
                                    :value="value('miscWithInterest')"
                                    tip-name="misc"
                                    title="Miscellaneous - Medication, Appliances, Additional Food & Energy Costs"
                                    updates="miscInterest">
                            </interest-item>
                            <interest-item
                                    v-if="value('pastCostOfCare') > 0"
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastCostOfCareInterest')"
                                    :option="{name: 'pastCostOfCare'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastCostOfCareWithInterest')"
                                    tip-name="pastCostOfCare"
                                    title="Past Cost of Care"
                                    updates="pastCostOfCareInterest">
                            </interest-item>
                        </div>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
        <step-button :next-valid="$valid() && allInterimPaymentsValid"></step-button>
        <modal :name="'interest_' + uniqueId" no-default-button="true">
            <modal-content></modal-content>
        </modal>
    </div>
</template>
<script>
    import moment from 'moment';
    import {mapActions, mapGetters} from 'vuex';
    import StepButton from 'components/StepButton';
    import Control from 'components/form/Control';
    import ControlError from 'components/form/control/Error';
    import DateInput from 'components/form/control/DateInput';
    import {setStepValid} from 'services/routingMethods';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Payment from './interim/Payment';
    import Modal from 'components/modal/Modal';
    import ModalContent from 'components/modal/ModalContent';
    import InterestItem from 'components/InterestItem';

    export default {
        name: 'InterimPaymentsAndInterest',
        computed: {
            ...mapGetters('personal/claimant', ['getIncomeValue', 'getClaimInfo']),
            ...mapGetters('personal/otherPastLosses', ['value', 'getAllCustomHeadOfLoss', 'getModalPayload']),
            ...mapGetters('personal/interimPayments', ['interimPayments', 'allInterimPaymentsValid']),
            ...mapGetters('personal/claimant', ['claimant']),
            showGeneralDamages() {
                return this.getClaimInfo('proceduralStatus') !== 'pre-lit';
            },
            pastLossOfEarnings: {
                get() {
                    return this.getIncomeValue('pastLossOfEarnings');
                },
                set(value) {
                    this.updateIncomeValue({key: 'pastLossOfEarnings', value});
                }
            },
            interestType: {
                get() {
                    return this.value('interestType');
                },
                set(value) {
                    this.setValue({key: 'interestType', value});
                }
            },
            customInterestDate: {
                get() {
                    return this.value('customInterestDate');
                },
                set(value) {
                    this.setValue({key: 'customInterestDate', value});
                }
            },
            payload: {
                get() {
                    return this.getModalPayload;
                },
            },
            uniqueId() {
                return this._uid;
            },
            isValidDate() {
                let mDate = moment(this.customInterestDate, 'DD/MM/YYYY');
                return (
                    mDate.isValid()
                );
            },
            isValidInterestDate() {
                let mDate = moment(this.customInterestDate, 'DD/MM/YYYY');
                let mDateOfInjury =  moment(this.getClaimInfo('dateOfInjury'), 'DD/MM/YYYY');
                return mDate.isAfter(mDateOfInjury);
            }
        },
        created() {
            setStepValid(true);
            this.calcAllInterest();
        },
        mixins: [
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        components: {
            StepButton,
            Control,
            ControlError,
            DateInput,
            Payment,
            Modal,
            ModalContent,
            InterestItem
        },
        methods: {
            ...mapActions('personal/otherPastLosses', {
                setValue: 'set',
                setCustomValue: 'setCustomHeadOfLossValue',
                calcAllInterest: 'calcAllInterest',
            }),
            ...mapActions('personal/interimPayments', ['addPayment']),
            onUpdate(info) {
                this.setValue({key: info.updates, value: info.value})
                    .then(this.calcAllInterest.bind(this));
            },
            onUpdateCustom(info) {
                this.setCustomValue({index: info.updates, value: info.value, key: 'interest'})
                    .then(this.calcAllInterest.bind(this));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InterimPayments.vue?6e4e95e1